(function (Translator) {
    // ro
    Translator.add("rate_list.rate.bg_kbcbank", "KBC Bank suma", "EvpThemeBundle", "ro");
    Translator.add("recaptcha.description", "Acest mesaj este destinat s\u0103 verifice dac\u0103 o persoan\u0103 navigheaz\u0103 \u0219i s\u0103 evite sistemele automate de verificare", "EvpThemeBundle", "ro");
    Translator.add("recaptcha.title", "Sunte\u021bi robot?", "EvpThemeBundle", "ro");
})(Translator);
